import deFlag from '@/assets/img/icons/de.svg'
import enFlag from '@/assets/img/icons/en.svg'
import frFlag from '@/assets/img/icons/fr.svg'

export const countryFlags = {
  fr: frFlag,
  en: enFlag,
  de: deFlag,
}